import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { UserContext } from "../../contexts/user.context.jsx";
import Navbar from "../navbar/navbar.comp.jsx";
import "./page.style.scss";
import { useParams } from 'react-router-dom';
import {
    getUserDoc,
    getPublicChallengesForUser,
    postUserDoc
} from "../../utils/firebase/firebase.utils.js";
import Button from "../button/button.comp.jsx";
import { useChallenge } from '../../contexts/challenges.context.jsx';
import ChallengeCard from "../challengeCard/challengeCard.comp.jsx";


const Page = () => {

    //Nav & Contexts
    const navigate = useNavigate();

    // [1] Inputs
    const { userID } = useContext(UserContext);
    const { setSelectedChallenge } = useChallenge();
    const { linkID } = useParams();


    // [2] GET USER DOC
    const [gotUserData, setGotUserData] = useState(false)
    const [pageDoc, setPageDoc] = useState(false)
    useEffect(() => {
        if (linkID) {
            const timer = setTimeout(async () => {
                const doc = await getUserDoc(linkID);

                console.log('Fechted This: ', doc)

                setPageDoc(doc)
                setGotUserData(true)

            }, 200);

            return () => clearTimeout(timer);
        } else {
            navigate('/'); // Redirect to home if no challenge is selected
        }

    }, [linkID]);


    // [2] GET CHALLENGES
    const [gotChallenges, setGotChallenges] = useState(false)
    const [challenges, setChallenges] = useState(false)
    const [filteredChallenges, setFilteredChallenges] = useState(challenges);
    useEffect(() => {
        if (linkID) {
            const timer = setTimeout(async () => {
                const theseChallenges = await getPublicChallengesForUser(linkID);

                console.log('Fechted These Challenges: ', theseChallenges)
                setChallenges(theseChallenges)
                setFilteredChallenges(theseChallenges)
                setGotChallenges(true)
            }, 200);

            return () => clearTimeout(timer);
        } else {
            navigate('/'); // Redirect to home if no challenge is selected
        }

    }, [linkID]);


    //[3] TOGGLING INFO
    const [displayInfo, setDisplayInfo] = useState(false);
    const toggleDisplay = () => {
        setDisplayInfo(!displayInfo)
    }

    // [3] SEARCHING
    const [searchValue, setSearchValue] = useState("");
    const handleClearSearch = () => {
        setSearchValue('')
    }
    useEffect(() => {
        if (searchValue === "") {
            setFilteredChallenges(challenges);
        } else {
            setFilteredChallenges(challenges.filter(challenge =>
                challenge.title.toLowerCase().includes(searchValue.toLowerCase()) ||
                challenge.about.toLowerCase().includes(searchValue.toLowerCase())
            ));
        }
    }, [searchValue, challenges]);


    //[3] NAVIGATE TO CHALLENGE
    const handleNavigateToChallenge = (challenge) => {
        setSelectedChallenge(challenge)
        navigate(`/challenge/${challenge.id}`);
    };


    //[3] ABOUT POP UP
    function formatCreatedAtToDateString(createdAt) {
        // Convert Firebase Timestamp to JavaScript Date object
        const date = new Date(createdAt.seconds * 1000);

        // Options for formatting the date (MMM-YYYY format)
        const options = { year: 'numeric', month: 'long' };

        // Format the date string and replace space with a dash
        return date.toLocaleDateString('en-US', options);
    }
    const handleOpenLink = (url) => {
        window.open(url, '_blank');
    };

    //[3] SHARE POP UP
    const [shareLinkCopied, setShareLinkCopied] = useState(false)
    const handleCopyShareLink = () => {

        const shareLink = `${window.location.origin}/page/${pageDoc.id}`;

        navigator.clipboard.writeText(shareLink).then(() => {
            console.log("Share link copied to clipboard: ", shareLink);
            setShareLinkCopied(true);
        }).catch(err => {
            console.error("Failed to copy share link: ", err);
        });
    }
    const [sharePopUp, setSharePopUp] = useState(false)
    const handleShare = () => {
        setSharePopUp(!sharePopUp)
        setShareLinkCopied(false)
    }


    // [2] EDIT CHANNEL
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const [anchor, setAnchor] = useState()
    const [editPage, setEditPage] = useState(false)
    const handleEditPage = () => {
        setEditPage(true)
        setAnchor(pageDoc)
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPageDoc(prevState => ({ ...prevState, [name]: value }));
    };
    const handleSaveChanges = async () => {

        console.log('Updating User Doc with this: ', pageDoc)

        try {
            setSaving(true)

            const posted = await postUserDoc(pageDoc.id, pageDoc);

            if (posted) {
                setSaving(false)
                setSaved(true)
            } else {
                alert('There was an error, please try again')
            }
        }
        catch (error) {
            console.error('Error toggling challenge status:', error);
        }
    }
    const handleCancelChanges = () => {
        setPageDoc(anchor)
        setEditPage(false)
    }
    const handleCloseEditChannel = () => {
        setEditPage(false)
        saved ? (
            setSaved(false)
        ) : (
            setPageDoc(anchor)
        )
    }


    return (
        <div>
            {/* Navbar */}
            <div className="section">
                <Navbar />
            </div>

            {!gotUserData && (
                <div className="loading-circle"></div>
            )}

            {/* Profile Header */}
            {gotUserData && (
                <div style={{
                    margin: '40px auto 40px',
                    width: '80%',
                    display: 'flex',
                    alignItems: "center",
                    gap: '20px'
                }}
                >
                    <div style={{
                        backgroundImage: `url(${pageDoc.imageURL})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        height: '180px',
                        width: '180px',
                        borderRadius: '50%'
                    }} />
                    <div style={{
                        display: 'flex',
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexGrow: 1
                    }}>
                        <h1 onClick={() => setDisplayInfo(true)}
                            style={{
                                width: 'fit-content',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.color = 'grey'}
                            onMouseLeave={(e) => e.currentTarget.style.color = 'black'}
                        >
                            {pageDoc.displayName}</h1>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '12px',
                            width: 'fit-content',
                            margin: '0 0 0 auto'
                        }}>
                            <Button text={'Share'} option={'blue-inverted'} onClick={handleShare} />
                            {linkID === pageDoc.id && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: '12px'
                                }}>
                                    <Button text={'Edit'} option={'button-linked-text'} onClick={handleEditPage} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Search Bar */}
            {gotUserData && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '80%',
                    margin: '20px auto'
                }}>
                    <input
                        type="text"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        placeholder="Filter challenges..."
                        style={{ padding: "8px", flex: 1, marginRight: "8px" }}
                    />
                    {
                        searchValue ? (
                            <div
                                className="close pointer"
                                style={{
                                    backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                }}
                                onClick={handleClearSearch}
                            >
                            </div>
                        ) : null
                    }
                </div>
            )}

            {/* Challenges */}
            {gotChallenges && (
                <div
                    className="card-display"
                    style={{
                        width: '80%',
                        margin: '12px auto'
                    }}
                >
                    {filteredChallenges.map((challenge, index) => {

                        return (
                            <ChallengeCard
                                key={index}
                                imageURL={challenge.imageURL}
                                title={challenge.title}
                                eventTime={challenge.eventTime}
                                eventsTotal={challenge.eventsTotal}
                                weeks={challenge.weeks}
                                about={challenge.about}
                                info={challenge.info}
                                onClick={() => handleNavigateToChallenge(challenge)}
                                video={challenge.videoURL}
                                videoURL={challenge.videoURL}
                                challengesLoaded={true}
                                noProfileImage={true}
                            />
                        )
                    })}
                </div>
            )}

            {/* Pop Up Info */}
            {displayInfo === true && (
                <div className="inf-pop-up-container">
                    <div className="inf-pop-up">
                        <div className="inf-pop-up-header">
                            <div className="title">
                                <h2>About</h2>
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={toggleDisplay}
                                >
                                </div>
                            </div>
                        </div>
                        <div className="inf-pop-up-scroll-view">
                            {
                                // Check if at least one of the social media links is present
                                pageDoc.youtube ||
                                    pageDoc.facebook ||
                                    pageDoc.instagram ||
                                    pageDoc.twitter ||
                                    pageDoc.myWebsiteLink ? (
                                    <div>
                                        {pageDoc.myWebsiteLink ? (
                                            <div className="link">
                                                <div className="link-icon-wrapper">
                                                    <div
                                                        className="link-icon"
                                                        style={{
                                                            backgroundImage: `url(${pageDoc.myWebsiteImageUrl})`,
                                                            backgroundSize: 'cover',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat'
                                                        }}
                                                    >
                                                    </div>
                                                </div>
                                                <div className="link-info">
                                                    <p>{pageDoc.myWebsiteName}</p>
                                                    <p onClick={() => handleOpenLink(pageDoc.myWebsiteLink)}>{pageDoc.myWebsiteLink}</p>
                                                </div>
                                            </div>
                                        ) : null
                                        }
                                        {
                                            pageDoc.youtube && (
                                                <div className="link">
                                                    <div className="link-icon-wrapper">
                                                        <div
                                                            className="link-icon"
                                                            style={{
                                                                backgroundImage: `url(${'https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/1024px-YouTube_full-color_icon_%282017%29.svg.png?20240107144800'})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat'
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                    <div className="link-info">
                                                        <p>youtube</p>
                                                        <p onClick={() => handleOpenLink(pageDoc.youtube)}>{pageDoc.youtube}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            pageDoc.facebook && (
                                                <div className="link">
                                                    <div className="link-icon-wrapper">
                                                        <div
                                                            className="link-icon"
                                                            style={{
                                                                backgroundImage: `url(${'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Facebook_icon_2013.svg/600px-Facebook_icon_2013.svg.png?20161223201621'})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat'
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                    <div className="link-info">
                                                        <p>facebook</p>
                                                        <p onClick={() => handleOpenLink(pageDoc.facebook)}>{pageDoc.facebook}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            pageDoc.instagram && (
                                                <div className="link">
                                                    <div className="link-icon-wrapper">
                                                        <div
                                                            className="link-icon"
                                                            style={{
                                                                backgroundImage: `url(${'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png'})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat'
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                    <div className="link-info">
                                                        <p>instagram</p>
                                                        <p onClick={() => handleOpenLink(pageDoc.instagram)}>{pageDoc.instagram}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            pageDoc.twitter && (
                                                <div className="link">
                                                    <div className="link-icon-wrapper">
                                                        <div
                                                            className="link-icon"
                                                            style={{
                                                                backgroundImage: `url(${'https://upload.wikimedia.org/wikipedia/commons/5/5a/X_icon_2.svg'})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat'
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                    <div className="link-info">
                                                        <p>x</p>
                                                        <p onClick={() => handleOpenLink(pageDoc.twitter)}>{pageDoc.twitter}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                ) : null
                            }

                            <div className="title">
                                <h2>Details</h2>
                            </div>
                            <div className="detail">
                                <div className="detail-icon-wrapper">
                                    <div
                                        className="detail-icon"
                                        style={{
                                            backgroundImage: `url(${'https://i.pinimg.com/474x/7c/0e/4e/7c0e4e447a43a52a3473690cac3e7a0b.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                    >
                                    </div>
                                </div>
                                <div className="detail-info">
                                    <p>{challenges.length} challenges</p>
                                </div>
                            </div>
                            <div className="detail">
                                <div className="detail-icon-wrapper">
                                    <div
                                        className="detail-icon"
                                        style={{
                                            backgroundImage: `url(${'https://static.vecteezy.com/system/resources/previews/005/988/959/original/calendar-icon-free-vector.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                    >
                                    </div>
                                </div>
                                <div className="detail-info">
                                    <p>joined {formatCreatedAtToDateString(pageDoc.createdAt)}</p>
                                </div>
                            </div>
                            {
                                pageDoc.location ? (
                                    <div className="detail">
                                        <div className="detail-icon-wrapper">
                                            <div
                                                className="detail-icon"
                                                style={{
                                                    backgroundImage: `url(${'https://previews.123rf.com/images/flatdesign/flatdesign2009/flatdesign200900365/154641614-globe-earth-icon-world-icon.jpg'})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                            </div>
                                        </div>

                                        <div className="detail-info">
                                            <p>{pageDoc.location}</p>
                                        </div>
                                    </div>
                                ) : null
                            }
                            <div className="footer-margin">
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Pop Up Share */}
            {sharePopUp === true && (
                <div className="share-pop-up-container">
                    <div className="share-pop-up">
                        <div className="share-pop-up-header">
                            <div className="title">
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleShare}
                                >
                                </div>
                            </div>
                            <div
                                style={{
                                    backgroundImage: `url(${pageDoc.imageURL})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    height: '200px',
                                    width: '200px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    borderRadius: '20px'
                                }}
                            >
                            </div>
                            <h3>{pageDoc.displayName}</h3>
                            {
                                shareLinkCopied ? (
                                    <div>
                                        <Button text={'Copied to clipboard!'} option={'blue-inverted-no-hover'} />
                                        <p style={{ fontSize: 'small', textAlign: 'center', margin: '0' }}>You can share this link with others!</p>
                                    </div>
                                ) : (
                                    <Button text={'Copy share link'} option={'green'} onClick={handleCopyShareLink} />
                                )
                            }
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Pop Up */}
            {editPage === true && (
                <div className="edit-channel-pop-up-container">
                    <div className="edit-channel-pop-up">
                        <div className="edit-channel-pop-up-header">
                            <div className="title">
                                <h2>Settings</h2>
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleCloseEditChannel}
                                >
                                </div>
                            </div>
                        </div>
                        {saving ? (
                            <div className="loading-circle"></div>
                        ) : saved ? (
                            <div>
                                <p>Update successful</p>
                                <Button text={'close'} option={'yellow'} onClick={handleCloseEditChannel} />
                            </div>
                        ) : (
                            <div className="edit-channel-pop-up-scroll-view">
                                <div>
                                    <div className="channel-display-name-input">
                                        <p style={{
                                            fontWeight: '500',
                                            color: 'var(--fontgrey)',
                                            fontSize: 'small',
                                            textAlign: 'left',
                                            marginTop: '8px',
                                            marginBottom: '4px'
                                        }}>Display Name</p>
                                        <input
                                            type="text"
                                            name="displayName"
                                            value={pageDoc.displayName}
                                            onChange={handleInputChange}
                                            placeholder="Display Name"
                                            maxLength={40}
                                        />
                                    </div>
                                    <div style={{ marginTop: '8px' }}>
                                        <p style={{
                                            fontWeight: '500',
                                            color: 'var(--fontgrey)',
                                            fontSize: 'small',
                                            textAlign: 'left',
                                            marginTop: '8px',
                                            marginBottom: '4px'
                                        }}>Image</p>
                                        <input
                                            type="text"
                                            name="imageURL"
                                            value={pageDoc.imageURL}
                                            onChange={handleInputChange}
                                            placeholder="Profile Image URL"
                                        />
                                    </div>
                                </div>

                                {/* About Settings */}
                                <div

                                    style={{ textAlign: 'left', marginBottom: '40px' }}
                                >
                                    <h3 style={{ textAlign: 'left', marginBottom: '8px' }}>About</h3>
                                    <p style={{ fontSize: 'small', marginTop: 0 }}>More details about your channel.</p>

                                    <div className="about-links-input">
                                        <p style={{
                                            fontWeight: '500',
                                            color: 'var(--fontgrey)',
                                            fontSize: 'small',
                                            textAlign: 'left',
                                            marginTop: '8px',
                                            marginBottom: '4px'
                                        }}>Links</p>
                                        <div>
                                            <input
                                                style={{ marginTop: '4px' }}
                                                name="youtube"
                                                value={pageDoc.youtube}
                                                onChange={handleInputChange}
                                                placeholder="youtube"
                                            />
                                            <input
                                                style={{ marginTop: '4px' }}
                                                name="facebook"
                                                value={pageDoc.facebook}
                                                onChange={handleInputChange}
                                                placeholder="facebook"
                                            />
                                            <input
                                                style={{ marginTop: '4px' }}
                                                name="instagram"
                                                value={pageDoc.instagram}
                                                onChange={handleInputChange}
                                                placeholder="instagram"
                                            />
                                            <input
                                                style={{ marginTop: '4px' }}
                                                name="twitter"
                                                value={pageDoc.twitter}
                                                onChange={handleInputChange}
                                                placeholder="twitter"
                                            />
                                        </div>
                                    </div>
                                    <div className="about-your-website-input">
                                        <p style={{
                                            fontWeight: '500',
                                            color: 'var(--fontgrey)',
                                            fontSize: 'small',
                                            textAlign: 'left',
                                            marginTop: '20px',
                                            marginBottom: '4px'
                                        }}>Your Website</p>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <input
                                                name="myWebsiteImageUrl"
                                                value={pageDoc.myWebsiteImageUrl}
                                                onChange={handleInputChange}
                                                placeholder="Image link"
                                            />
                                            <input
                                                name="myWebsiteName"
                                                value={pageDoc.myWebsiteName}
                                                onChange={handleInputChange}
                                                placeholder="Name"
                                            />
                                            <input
                                                name="myWebsiteLink"
                                                value={pageDoc.myWebsiteLink}
                                                onChange={handleInputChange}
                                                placeholder="Website Url"
                                            />
                                        </div>
                                    </div>
                                    <div className="about-your-website-input">
                                        <p style={{
                                            fontWeight: '500',
                                            color: 'var(--fontgrey)',
                                            fontSize: 'small',
                                            textAlign: 'left',
                                            marginTop: '20px',
                                            marginBottom: '4px'
                                        }}>Location</p>
                                        <div>
                                            <input
                                                name="location"
                                                value={pageDoc.location}
                                                onChange={handleInputChange}
                                                placeholder="Location"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: 'auto', marginBottom: '0' }}>
                                    <Button text={'cancel'} option={'yellow'} onClick={handleCancelChanges} />
                                    <Button text={'save'} option={'green'} onClick={handleSaveChanges} />
                                </div>
                                <div className="footer-margin">
                                </div>
                            </div>
                        )
                        }
                    </div>
                </div>
            )}


            <div className="footer-margin">
            </div>
        </div >
    );
};

export default Page;